module.exports = __webpack_public_path__ + "static/media/Ice Skater.10cb17e8.jpg";